<script setup lang="ts">
import { computed, ref } from 'vue'

import type { ProcessableImage } from '../../types/common.types'
import { setCssValueUnity } from '../helpers/ui'
import type { TypographyVariants } from '../types/ui'

import BoxComponent from './BoxComponent.vue'
import ColorAvatarComponent from './ColorAvatarComponent.vue'
import ImageComponent from './ImageComponent.vue'

const props = withDefaults(
  defineProps<{
    image?: ProcessableImage
    name: string
    size: number
    alt?: string
    variant?: TypographyVariants
  }>(),
  { size: 32, alt: 'Profile Image', variant: 'title-large' },
)

const width = computed(() => setCssValueUnity(props.size))
const height = computed(() => setCssValueUnity(props.size))

const hasValidImage = computed(() => !!props.image && !!(props.image.key || props.image.url))

const imageFailed = ref(false)
const handleImageError = () => {
  imageFailed.value = true
}
</script>

<template>
  <BoxComponent :w="size" :h="size">
    <ImageComponent
      v-if="hasValidImage && !imageFailed"
      :image="image!"
      :width="size"
      :height="size"
      :alt="alt"
      class="avatar__img"
      @on-load-error="handleImageError"
    />

    <ColorAvatarComponent v-else :name="name" :size="size" :variant="variant" />
  </BoxComponent>
</template>

<style scoped lang="scss">
.avatar__img {
  width: v-bind(width);
  height: v-bind(height);
  min-width: v-bind(width);
  min-height: v-bind(height);
  border-radius: 100%;
}
</style>
